import { NavGraph, Document } from 'src/types/navGraph';

const searchByDocumentId = (
    documentId: number,
    node: any
): Document | undefined => {
    if (node.documents && node.documents[documentId]) {
        return node.documents[documentId];
    }
    if (node.children) {
        for (const child of Object.values(node.children)) {
            const result = searchByDocumentId(documentId, child);
            if (result) return result;
        }
    }
    return undefined;
};

export const findInNavGraphV2 = (
    documentId: number,
    navGraph: NavGraph
): Document | undefined => {
    if (!navGraph) return undefined;

    for (const rootNode of Object.values(navGraph)) {
        const result = searchByDocumentId(documentId, rootNode);
        if (result) return result;
    }
    return undefined;
};
